import { useRestaurantStore } from "@/stores/restaurantStore";

/**
 * Returns active restaurant id from guard-resolved context.
 * Throws when used outside the authenticated restaurant context.
 */
export function useRestaurantId(): string {
  const restaurantId = useRestaurantStore((s) => s.activeRestaurantId);
  if (!restaurantId) {
    throw new Error(
      "useRestaurantId: no active restaurant — must be inside RestaurantGuard"
    );
  }
  return restaurantId;
}
